import { render, staticRenderFns } from "./lgg-title.vue?vue&type=template&id=e752a4d4&scoped=true&"
import script from "./lgg-title.vue?vue&type=script&lang=js&"
export * from "./lgg-title.vue?vue&type=script&lang=js&"
import style0 from "./lgg-title.vue?vue&type=style&index=0&id=e752a4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e752a4d4",
  null
  
)

export default component.exports